import { render, staticRenderFns } from "./TsDropdown.vue?vue&type=template&id=fa1c2d9e&"
import script from "./TsDropdown.vue?vue&type=script&lang=ts&"
export * from "./TsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports